import { render, staticRenderFns } from "./ModalNuovaTarga.vue?vue&type=template&id=72c2deda&scoped=true&"
import script from "./ModalNuovaTarga.vue?vue&type=script&lang=js&"
export * from "./ModalNuovaTarga.vue?vue&type=script&lang=js&"
import style0 from "./ModalNuovaTarga.vue?vue&type=style&index=0&id=72c2deda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c2deda",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./modules/Home/views/src/components/ModalNuovaTarga.vue
// module id = 359
// module chunks = 0